import { useContext } from "react";

import { HEADING_TAGS } from "../../lib/tags.ts";

import { HeadingLevelContext } from "./context.ts";

export function useHeadingLevel(): number {
  const level = useContext(HeadingLevelContext);

  return Math.min(Math.max(level, 1), HEADING_TAGS.length);
}
